import { 
    FaHome, 
    // FaBoxes, 
    FaShoppingBag, 
    FaTicketAlt, 
    // FaHeart,
    FaChartLine,
    FaReceipt,
    FaTable,
    FaChartBar,
    FaFileInvoiceDollar,
    FaListOl
} from 'react-icons/fa'
import { useAdministrativeContext } from '../../../../pages/administrativePanel/administrativePanelContext'

import { Container } from './styles'

export function Header () {
    const { informationsToShowInPage } = useAdministrativeContext()


    return(
        <Container>
            {
                informationsToShowInPage === 'home' ?
                <>
                    <FaHome />
                    <h1>Home</h1>
                </>
                :  informationsToShowInPage === 'orders' ?
                <>
                    <FaShoppingBag />
                    <h1>Pedidos</h1>
                </>
                : informationsToShowInPage === 'coupons' ?
                <>
                    <FaTicketAlt />
                    <h1>Cupons</h1>
                </>
                : informationsToShowInPage === 'dashboard' ?
                <>
                    <FaChartLine />
                    <h1>Dashboard</h1>
                </>
                : informationsToShowInPage === 'clube' ?
                <>
                    <FaTable />
                    <h1>Clube</h1>
                </>
                : informationsToShowInPage === 'ordersSummary' ?
                <>
                    <FaReceipt />
                    <h1>Pedidos</h1>
                </>
                : informationsToShowInPage === 'sales' ?
                <>
                    <FaReceipt />
                    <h1>Vendas</h1>
                </>
                : informationsToShowInPage === 'curveAbc' ?
                <>
                    <FaChartBar/>
                    <h1>Curva ABC das Empresas</h1>
                </>
                : informationsToShowInPage === 'goals' ?
                <>
                    <FaChartBar/>
                    <h1>Metas</h1>
                </>
                : informationsToShowInPage === 'products' ?
                <>
                     <FaChartBar/>
                     <h1>Curva ABC dos Produtos</h1>
                </>
                : informationsToShowInPage === 'monthlyBilling'?
                <>
                    <FaFileInvoiceDollar/>
                    <h1>Faturamento Mensal</h1>
                </>
                : informationsToShowInPage === 'salesChannelBilling'?
                <>
                    <FaFileInvoiceDollar/>
                    <h1>Faturamento por Canal de Venda</h1>
                </>
                : informationsToShowInPage === 'line' ?
                <>
                    <FaListOl/>
                    <h1>Relatório de filas</h1> 
                </>
                :<></>
            }

        </Container>
    )
}